import script from "./PatientForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientForm.vue?vue&type=script&setup=true&lang=js"

import "./PatientForm.vue?vue&type=style&index=0&id=27b05bfa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27b05bfa"]])

export default __exports__